import { useBreakpointUp } from 'shared/hooks/useBreakpointQueries'
import { DateDialog } from './DateDialog'
import { DatePopper } from './DatePopper'

interface DateSelectProps{
    className?: string
    open: boolean
    onClose?: (event: any) => void
    onCancel?: (event: any) => void
    onOk?: (event: any) => void
    anchorEl?: any
    popperOptions?: any
    loading?: boolean
    customDay?: any
}

export const DateSelect = (props: DateSelectProps) => {
    const {
        className,
        open,
        onClose,
        onCancel,
        onOk,
        anchorEl,
        popperOptions,
        loading,
        customDay
    } = props
    
    const isXlWidthScreenOrMore = useBreakpointUp('xl')
    const handleDateDialogClose = (event: any) => {
        onClose?.(event)
    }

    const handleDatePopperCancel = (event: any) =>{
        onCancel?.(event)
    }

    const handleDatePopperOk = (event: any) => {
        onOk?.(event)
    }

    const handleDateDialogOk = (event: any) => {
        onOk?.(event)
    }

    if (isXlWidthScreenOrMore){
        return (
            <DatePopper 
                open={open}
                popperOptions={popperOptions}
                anchorEl={anchorEl}
                onCancel={handleDatePopperCancel}
                onOk={handleDatePopperOk}
                customDay={customDay}
            />
        )
    }

    return (
        <DateDialog
            open={open}
            onClose={handleDateDialogClose}
            onCancel={handleDatePopperCancel}
            customDay={customDay}
            onOk={handleDateDialogOk}
        />
    )
}